import React from 'react';

const shimmer: React.CSSProperties = {
  background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
  backgroundSize: '200% 100%',
  animation: 'shimmer 2s infinite',
};

const ExpensesSkeletonLoader: React.FC = () => {
  return (
    <>
      <div
        style={{
          background: 'white',
          borderRadius: 20,
          boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
          border: '1px solid #e5e7eb',
          overflow: 'hidden',
          width: '100%',
        }}
      >
        {/* Info bar */}
        <div
          style={{
            padding: '16px 20px',
            borderBottom: '1px solid #f3f4f6',
            background: '#fafbfc',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <div style={{ width: 32, height: 32, borderRadius: 8, ...shimmer }} />
            <div style={{ width: 220, height: 16, borderRadius: 8, ...shimmer }} />
          </div>
          <div style={{ width: 90, height: 32, borderRadius: 8, ...shimmer }} />
        </div>

        {/* Rows — # · Payee · Category · Amount · Payment · Description · Date · Status · Actions */}
        <div style={{ padding: 20 }}>
          {[...Array(10)].map((_, index) => (
            <div
              key={index}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 16,
                padding: 16,
                borderBottom: index < 9 ? '1px solid #f3f4f6' : 'none',
                animation: 'pulse 1.5s ease-in-out infinite',
                animationDelay: `${index * 0.1}s`,
              }}
            >
              {/* Serial */}
              <div style={{ width: 28, height: 28, borderRadius: 6, flexShrink: 0, ...shimmer }} />

              {/* Payee (name + contact) */}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ width: '70%', height: 15, borderRadius: 8, marginBottom: 8, ...shimmer }} />
                <div style={{ width: '45%', height: 12, borderRadius: 8, ...shimmer }} />
              </div>

              {/* Category pill */}
              <div style={{ width: 100, height: 26, borderRadius: 8, flexShrink: 0, ...shimmer }} />

              {/* Amount */}
              <div style={{ width: 90, height: 16, borderRadius: 8, flexShrink: 0, ...shimmer }} />

              {/* Payment (mode + ref) */}
              <div style={{ width: 120, flexShrink: 0 }}>
                <div style={{ width: '80%', height: 14, borderRadius: 8, marginBottom: 6, ...shimmer }} />
                <div style={{ width: '55%', height: 12, borderRadius: 8, ...shimmer }} />
              </div>

              {/* Description */}
              <div style={{ width: 160, height: 14, borderRadius: 8, flexShrink: 0, ...shimmer }} />

              {/* Date */}
              <div style={{ width: 90, height: 14, borderRadius: 8, flexShrink: 0, ...shimmer }} />

              {/* Status pill */}
              <div style={{ width: 100, height: 26, borderRadius: 20, flexShrink: 0, ...shimmer }} />

              {/* Actions (up to 5: view, approve, reject, edit, delete) */}
              <div style={{ display: 'flex', gap: 4, justifyContent: 'center', flexShrink: 0 }}>
                {[...Array(5)].map((_, i) => (
                  <div
                    key={i}
                    style={{
                      width: 32,
                      height: 32,
                      borderRadius: '50%',
                      ...shimmer,
                    }}
                  />
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Pagination */}
        <div
          style={{
            background: '#fafbfc',
            borderTop: '1px solid #e5e7eb',
            padding: '20px 16px',
            display: 'flex',
            justifyContent: 'center',
            gap: 8,
          }}
        >
          {[...Array(7)].map((_, i) => (
            <div
              key={i}
              style={{
                width: 36,
                height: 36,
                borderRadius: 8,
                ...shimmer,
              }}
            />
          ))}
        </div>
      </div>

      <style>{`
        @keyframes shimmer {
          0% { background-position: -200% 0; }
          100% { background-position: 200% 0; }
        }
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
      `}</style>
    </>
  );
};

export default ExpensesSkeletonLoader;